"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerComponent = void 0;
var PlayerComponent;
(function (PlayerComponent) {
    PlayerComponent["Core"] = "core";
    PlayerComponent["SomAdScheduler"] = "som-ad-scheduler";
    PlayerComponent["Bootstrap"] = "bootstrap";
    PlayerComponent["Ui"] = "ui";
    PlayerComponent["Monetization"] = "monetization";
    PlayerComponent["OasisCoral"] = "oasis-coral";
    PlayerComponent["PlayerFeedback"] = "player-feedback";
    PlayerComponent["SourceFetcher"] = "source-fetcher";
    PlayerComponent["AdViewability"] = "ad-viewability";
    PlayerComponent["OpenMeasurement"] = "open-measurement";
    PlayerComponent["Silverback"] = "silverback";
})(PlayerComponent = exports.PlayerComponent || (exports.PlayerComponent = {}));
//# sourceMappingURL=player-config.js.map